/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Plan_Superset_Round_RestInputs */

const en_us2_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s rest after the round`)
};

const pt_br2_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de descanso após a rodada`)
};

const es_419_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de descanso después de la ronda`)
};

const pt_pt2_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de descanso após a ronda`)
};

const fr_fr2_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de repos après le tour`)
};

const de_de2_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s Pause nach der Runde`)
};

const it_it2_plan_superset_round_rest = /** @type {(inputs: Plan_Superset_Round_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s di recupero dopo il giro`)
};

/**
* | output |
* | --- |
* | "{seconds} s rest after the round" |
*
* @param {Plan_Superset_Round_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_superset_round_rest = /** @type {((inputs: Plan_Superset_Round_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Superset_Round_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_superset_round_rest(inputs)
	if (locale === "es-419") return es_419_plan_superset_round_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_superset_round_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_superset_round_rest(inputs)
	if (locale === "de-DE") return de_de2_plan_superset_round_rest(inputs)
	if (locale === "it-IT") return it_it2_plan_superset_round_rest(inputs)
	return en_us2_plan_superset_round_rest(inputs)
});
export { plan_superset_round_rest as "plan.superset_round_rest" }